export default __webpack_public_path__ + "static/media/dartDrop.b308aa22.m4a";